module.exports = __webpack_public_path__ + "static/media/mps1.25ccc598.jpg";